// TXT-06 (Mario, 28-oct): la cascada de «Composición del neto». En cobranza no hay vendido: arranca en lo cobrado.
// TXT-07 (H-50): en cesión, el renglón «− Iniciales (las cobró el comercio)» entre lo vendido y las comisiones.
// Funciones puras (las prueba test/liquidacion-textos-release-28.test.mjs sin Angular).
export const cascadaDe = (c: any): any[] => {
  if (!c) return [];
  const vendido = Number(c.vendido) || 0, cobrado = Number(c.cobrado) || 0, total = vendido + cobrado;
  if (!total) return [];
  const inicial = Number(c.inicial) || 0;
  const entra = [['Vendido', vendido], ['Cobrado', cobrado]].filter((e) => e[1]);
  const pasos = [...entra.map((e) => [e[0], e[1], 'b']), ...(inicial > 0 ? [['Iniciales (las cobró el comercio)', -inicial, 'r']] : []), ['Comisiones', -c.comision, 'r'], ['Cargos', -c.cargo, 'r'], ['Ajustes y arrastres', c.ajustes, c.ajustes < 0 ? 'r' : 'b'], ['Neto al comercio', c.neto, 'n']];
  let base = 0;
  return pasos.map((p) => {
    const et = p[0], v = Number(p[1]) || 0, tipo = p[2];
    let desde = 0;
    if (tipo !== 'n') { desde = v < 0 ? base + v : base; base += v; }
    return { et, v, tipo, abs: Math.abs(v), desde: (desde / total) * 100, w: Math.max(0.6, (Math.abs(v) / total) * 100) };
  });
};

export const baseDeCreditotal = (c: any): string => {
  const vendido = Number(c && c.vendido) || 0, cobrado = Number(c && c.cobrado) || 0;
  return vendido && cobrado ? 'de lo vendido y cobrado' : cobrado ? 'de lo cobrado' : 'de lo vendido';
};
